import React from "react";
import clsx from "clsx";
import { NavLinkList } from "./config";
import { NavLink, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import "./style.scss";
import { Tooltip } from "@material-ui/core";
import DexterLogo from "../../img/new_navbar/Dexter.png";
import MenuOpenIcon from "../../img/new_navbar/menu_open.svg";
import Avatar from "@material-ui/core/Avatar";
import { signOut } from "../../store/actions/authAction";
import LogoutIcon from "./img/logout.svg";
import ChevronDownIcon from "../../img/chevron_down.svg";
import ChevronDownSelectedIcon from "../../img/chevron_down_selected.svg";
import { filterByUserScope } from "../../utilities/helpers";
import { updateFilterHide } from "../../store/actions/filterAction";
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
class NewNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hide: false,
      showSignOut: false,
      expandedSubmenus: {},
    };
  }
  toggleHide = () => {
    this.setState((prevstate) => ({ hide: !prevstate.hide }));
  };

  toggleSubmenu = (itemName) => {
    this.setState((prevState) => ({
      expandedSubmenus: {
        ...prevState.expandedSubmenus,
        [itemName]: !prevState.expandedSubmenus[itemName],
      },
    }));
  };
  render() {
    const userName = localStorage.getItem("name") ?? null;
    const userAlias = localStorage.getItem("alias") ?? null;
    const currentPath = this.props.history.location.pathname;

    if (currentPath === "/quiz" || currentPath === "/reset_password")
      return null;
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;
    return currentPath !== "/" &&
      currentPath !== "/signin" &&
      currentPath !== "/reset_password" ? (
      <div
        className={
          this.state.hide
            ? "main-app-new-navbar hidden-nav"
            : "main-app-new-navbar"
        }
      >
        <div className="new-nav-title-bar">
          <img src={DexterLogo} alt="Dexter Logo" />
          <button onClick={this.toggleHide}>
            <img src={MenuOpenIcon} alt="Menu Open Icon" />
          </button>
        </div>
        <div className="new-nav-user-info-bar">
          <Tooltip
            title={this.state.hide ? JSON.parse(userName) : ""}
            placement="right"
            arrow
          >
            <Avatar
              style={{
                background: "#e2146e",
                width: 35,
                height: 35,
                fontWeight: 700,
              }}
            >
              {userName ? capitalizeFirstLetter(JSON.parse(userName)[0]) : ""}
            </Avatar>
            {/* <img src={AvatarIcon} /> */}
          </Tooltip>
          <div className="new-nav-user-info">
            <h4>{userAlias && capitalizeFirstLetter(JSON.parse(userAlias))}</h4>
            <p>{userName && JSON.parse(userName)}</p>
          </div>
          {/* <div className="signout-container">
            <img src={DotIcon} />
          </div> */}
        </div>

        <div className="new-nav-link-container">
          {NavLinkList.filter(filterByUserScope).map((item) => {
            if (item.submenu) {
              const isExpanded = this.state.expandedSubmenus[item.name];
              const isActive = item.submenu.some(
                (subItem) => subItem.to === currentPath
              );
              return (
                <div key={item.to} className="nav-item-with-submenu">
                  <div
                    className={clsx(
                      "new-navigation-link",
                      isExpanded && "submenu-parent"
                    )}
                    style={{
                      background: isActive ? "white" : "transparent",
                      color: isActive ? "#E2136E" : "#362B73",
                    }}
                    onClick={() => this.toggleSubmenu(item.name)}
                  >
                    <Tooltip
                      title={this.state.hide ? item.name : ""}
                      placement="right"
                      arrow
                    >
                      <img
                        src={
                          isActive
                            ? (item.iconSelected ?? item.icon)
                            : item.icon
                        }
                        alt="nav-menu-icon"
                      />
                    </Tooltip>
                    <span className="submenu-parent-title">{item.name}</span>
                    <div
                      className={clsx(
                        "submenu-arrow",
                        isExpanded && "expanded"
                      )}
                    >
                      <img
                        src={
                          isActive ? ChevronDownSelectedIcon : ChevronDownIcon
                        }
                        alt="Submenu Arrow Icon"
                        style={{
                          transform: isExpanded
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                        className="submenu-arrow-icon"
                      />
                    </div>
                  </div>
                  {isExpanded && (
                    <div
                      className="submenu-container"
                      style={{
                        background: isActive ? "white" : "transparent",
                        color: isActive ? "#E2136E" : "#362B73",
                      }}
                    >
                      {item.submenu.filter(filterByUserScope).map((subItem) => (
                        <NavLink
                          to={subItem.to}
                          key={subItem.to}
                          className="new-navigation-link submenu-item"
                          style={{
                            background:
                              subItem.to === currentPath
                                ? "#362B730A"
                                : "transparent",
                            color:
                              subItem.to === currentPath
                                ? "#E2136E"
                                : "#362B73",
                          }}
                        >
                          <Tooltip
                            title={this.state.hide ? subItem.name : ""}
                            placement="right"
                            arrow
                          >
                            <img
                              src={
                                currentPath === subItem.to
                                  ? (subItem.iconSelected ?? subItem.icon)
                                  : subItem.icon
                              }
                              alt="nav-sub-menu-icon"
                            />
                          </Tooltip>
                          <span>{subItem.name}</span>
                        </NavLink>
                      ))}
                    </div>
                  )}
                </div>
              );
            } else {
              const isActive = item.to === currentPath;
              return (
                <NavLink
                  to={item.to}
                  key={item.to}
                  className="new-navigation-link"
                  style={{
                    background: isActive ? "white" : "transparent",
                    color: isActive ? "#E2136E" : "#362B73",
                  }}
                >
                  <Tooltip
                    title={this.state.hide ? item.name : ""}
                    placement="right"
                    arrow
                  >
                    <img
                      src={
                        isActive ? (item.iconSelected ?? item.icon) : item.icon
                      }
                      alt="nav-menu-icon"
                    />
                  </Tooltip>
                  <span>{item.name}</span>
                </NavLink>
              );
            }
          })}
        </div>
        {true && (
          <div className="signout-link-container">
            <button onClick={this.props.signOut} className="new-signout-link">
              <Tooltip
                title={this.state.hide ? "Sign Out" : ""}
                placement="right"
                arrow
              >
                <img src={LogoutIcon} alt="Logout Icon" />
              </Tooltip>

              {!this.state.hide && "Sign Out"}
            </button>
          </div>
        )}
      </div>
    ) : null;
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    authToken: state.auth.authToken,
    filterElements: state.filterElement,
    filterHide: state.filter.filterHide,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateFilterHide: (filterHide) => dispatch(updateFilterHide(filterHide)),
    signOut: () => dispatch(signOut()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NewNavbar)
);
